<div class="document-container" dir="rtl">
  <div class="form-wrapper">
    <!-- Floating Title -->
    <div class="main-title">
      <h2>المستندات المطلوبة</h2>
    </div>

    <!-- Form Section -->
    <div class="form-section">
      <form [formGroup]="documentsForm">
        <fieldset [disabled]="isReadOnly" class="readonly-fieldset">
          <div class="documents-list">
            <!-- Loop through documents -->
            <div class="document-item" *ngFor="let doc of filteredDocs">
              <!-- Use reusable file-upload component -->
              <app-file-upload [label]="doc.label" [required]="true"
                tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF كما يجب إرفاق مستند اثبات الشخصيه علي الوجهين"
                acceptedTypes=".pdf"  [errorMessage]="'يرجى تحميل ' + doc.label + ' (PDF فقط)'"
                filePath="{{filePath}}"
                [formControlName]="doc.id"
                (uploadComplete)="onUploadComplete($event,doc.id, doc.preEstablishmentKey)"
                (fileRemoved)="onFileRemoved(doc.id, doc.preEstablishmentKey)">
              </app-file-upload>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</div>
